import {IController, IModule, IOnChangesObject} from "angular";
import {Kontekst} from "felles/tjenester/Kontekst";
import {l} from "types/typescriptdefinisjoner_lederplan";
import {WebNavigasjon} from "web/tjenester/WebNavigasjon";

const css = require('./aksepterteBetingelser.scss');

export class AksepterteBetingelserKontroller implements IController {

    static registrerKomponent(angular: IModule) {
        angular
            .component('wmAvtaleAksepterteBetingelser', {
                bindings: {avtale: '<'},
                controller: AksepterteBetingelserKontroller.forInjisering(),
                template: require('./aksepterteBetingelser.html')
            });
    }

    static forInjisering() {
        return [
            WebNavigasjon.regNavn,
            Kontekst.regNavn,
            AksepterteBetingelserKontroller
        ]
    }

    constructor() {
    }

    avtale: l.AvtaledetaljerModell; //settes via bindings/$onChanges

    $onChanges(changes: IOnChangesObject): void {
    }

}

